/**
 * created by tianruojun
 * 编辑器表单布局配置项
 * 每行总宽24
 */
export const informationConfig = {
    default:24,
    summary:24,
    author:8,
    phone:8,
    photography:8,
    camera:8,
    editor:8,
};